import { Button, ButtonGroup, Grid, Link, TableCell, TableRow, Tooltip, Typography } from "@material-ui/core";
import React, { useEffect } from "react";
import CardNumber from "../../components/CardNumber";
import PageCustom from "../../components/PageCustom";
import CustomTable from "../../components/CustomTable";
import PlatformRequest from "../../utils/PlatformRequest";
import CarTypeIcon from "../../components/CarTypeIcon";
import LineChart from "../../components/LineChart";

const DashboardPage = () => {
  const [searches, setSearches] = React.useState([])
  const [loadResumse, setLoadResume] = React.useState(false)
  const [buttonVariant, setButtonVariant] = React.useState({
    today: "outlined",
    seven: "contained",
    fifteen: "outlined",
    thirty: "outlined",
  })
  const [resume, setResume] = React.useState([
    {
      day: "",
      partFoundQuantity: 0,
      unansweredQuantity: 0,
      receivedQuantity: 0,
      partNotFoundQuantity: 0
    }
  ])
  const [sumQuantity, setSumQuantity] = React.useState({
    unanswared: 0,
    received: 0,
    partNotFound: 0,
    partFound: 0
  })
  const [providerData, setProviderData] = React.useState({
    labels: resume.map((data) => data.day),
    datasets: [],
  })

  useEffect(() => {
    loadSearchs()
    loadResume(7)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const loadSearchs = () => {
    PlatformRequest.getSearches(0, 5).then((response) => {
      setSearches(response.body.searchList)
    })
  }

  const loadResume = (period) => {
    setLoadResume(true)
    PlatformRequest.getResumeProvider(period).then((response) => {
      const { body } = response
      const { info } = body
      const { total } = body

      setResume(info)
      setSumQuantity({
        unanswared: total.unansweredTotal,
        received: total.receivedTotal,
        partNotFound: total.partNotFoundTotal,
        partFound: total.partFoundTotal
      })

      setProviderData({
        labels: info.map((data) => data.day),
        datasets: [
          {
            label: "Peça Encontrada",
            data: info.map((data) => data.partFoundQuantity),
            borderColor: "green",
            borderWidth: 5,
            fill: false,
            tension: 0.1
          },
          {
            label: "Não Respondidas",
            data: info.map((data) => data.unansweredQuantity),
            borderColor: "red",
            borderWidth: 5,
            fill: false,
            tension: 0.1
          },
          {
            label: "Recebidas",
            data: info.map((data) => data.receivedQuantity),
            borderColor: "blue",
            borderWidth: 5,
            fill: false,
            tension: 0.1
          },
          {
            label: "Peça Não Encontrada",
            data: info.map((data) => data.partNotFoundQuantity),
            borderColor: "gray",
            borderWidth: 5,
            fill: false,
            tension: 0.1
          },
        ],
      })

      setLoadResume(false)
    })
  }

  const changePeriod = (period) => {
    setButtonVariant({
      today: period === 1 ? "contained" : "outlined",
      seven: period === 7 ? "contained" : "outlined",
      fifteen: period === 15 ? "contained" : "outlined",
      thirty: period === 30 ? "contained" : "outlined",
    })

    loadResume(period)
  }

  return (
    <PageCustom title="Deixa Que Eu Procuro">

      <Grid container
        direction="row"
        spacing={4}
        justify="space-between"
        alignItems="baseline">
        <Grid item>
          <Typography gutterBottom>
            minhas buscas
          </Typography>
        </Grid>

        <Grid item>
          <Grid container
            direction="row"
            spacing={2}
            justify="space-between"
            alignItems="flex-end">

            <Grid item>
              <ButtonGroup size="large" color="secondary" aria-label="large outlined primary button group">
                <Button onClick={() => { changePeriod(1) }} variant={buttonVariant.today}>Hoje</Button>
                <Button onClick={() => { changePeriod(7) }} variant={buttonVariant.seven}>7 dias</Button>
                <Button onClick={() => { changePeriod(15) }} variant={buttonVariant.fifteen}>15 dias</Button>
                <Button onClick={() => { changePeriod(30) }} variant={buttonVariant.thirty}>30 dias</Button>
              </ButtonGroup>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <br />
      <Grid container
        spacing={2}
        direction="row"
        justify="center"
        alignItems="flex-start">

        <Grid item xs={12} sm={12} md={12}>
          <Grid container
            spacing={2}
            direction="row"
            justify="center"
            alignItems="center">
            <Grid item lg={3} sm={12} md={6} xs={12}>
              <CardNumber load={loadResumse} title="recebidas" number={sumQuantity.received} background={"#FFF"} textColor="#000" />
            </Grid>
            <Grid item lg={3} sm={12} md={6} xs={12}>
              <CardNumber load={loadResumse} title="encontradas" number={sumQuantity.partFound} background={"#cfcfcfb3"} textColor="#000" />
            </Grid>
            <Grid item lg={3} sm={12} md={6} xs={12}>
              <CardNumber load={loadResumse} title="não possui" number={sumQuantity.partNotFound} background={"#FFF"} textColor="#000" />
            </Grid>
            <Grid item lg={3} sm={12} md={6} xs={12}>
              <CardNumber load={loadResumse} title="não respondidas" number={sumQuantity.unanswared} background={"#cfcfcfb3"} textColor="#000" />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <br /><br />
      <Grid container
        spacing={3}
        direction="row"
        justify="center"
        alignItems="flex-start">

        <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
          <Grid container direction="row" justify="flex-end" alignItems="center" spacing={2}>

            <Grid item xs={12} sm={12} md={12}>
              <Typography gutterBottom>
                últimas buscas
              </Typography>
              <CustomTable
                title={["Tipo", "Descrição", "Data"]}
                items={searches.map((search) => (
                  <TableRow key={search.id} hover onClick={() => { console.log("open the search") }}>
                    <Tooltip title={search.carType} placement="left">
                      <TableCell align="left">
                        <CarTypeIcon type={search.carType} />
                      </TableCell>
                    </Tooltip>
                    <TableCell
                      onClick={() => { window.open(`/search/${search.id}`, "_blank") }}
                      component="th" scope="row" align="left">
                      {search.description}
                    </TableCell>
                    <TableCell align="left">{search.createdAt}</TableCell>
                  </TableRow>
                ))
                } />
            </Grid>

            {/* <Grid item xs={8} sm={8} md={8}></Grid> */}
            <Grid item>
              <Link href={`/search`}>Ver mais</Link>
            </Grid>
          </Grid>

        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
          <br />
          <LineChart data={providerData} load={loadResumse} />
        </Grid>
      </Grid>

    </PageCustom>
  )
}

export default DashboardPage;
